module.exports = {
	"order_failure_kinds": {
		"id": "ID",
		"category": "Category",
		"provider": "Provider",
		"code": "Code",
		"message": "Message",
		"categories": {
			"system": "Technical issues, network, integration",
			"validation": "Data errors, malformed request",
			"business": "Product business rules, non-financial",
			"funds": "Availability of funds",
			"issuer": "Bank and processing decisions",
			"account": "User or recipient account status",
			"risk": "Risk, compliance, regulatory",
			"auth": "Session lifecycle"
		},
		"responsibility": "Responsibility",
		"responsibilities": {
			"platform": "Platform",
			"provider": "Provider",
			"processor": "Processor",
			"issuer": "Issuer",
			"user": "User"
		},
		"kind": "Kind",
		"kinds": {
			"unknown_failure": "Unknown failure",
			"3ds_failed": "3ds failed",
			"3ds_declined": "3ds declined",
			"3ds_rejected": "3ds rejected",
			"3ds_expired": "3ds expired",
			"3ds_timeout": "3ds timeout",
			"invalid_cvv": "Invalid cvv",
			"invalid_amount": "Invalid amount",
			"customer_deposit_limit_reached": "Customer deposit limit reached",
			"invalid_data": "Invalid data",
			"invalid_account": "Invalid account",
			"invalid_card_number": "Invalid card number",
			"card_expired": "Card expired",
			"insufficient_funds": "Insufficient funds",
			"partial_authorization_less_than_min_amount": "Partial authorization less than min amount",
			"partial_approval_not_allowed": "Partial approval not allowed",
			"partial_cancelled": "Partial cancelled",
			"auto_timeout": "Auto timeout",
			"canceled": "Canceled",
			"provider_possible_fraud": "Provider possible fraud",
			"provider_unavailable": "Provider unavailable",
			"provider_timeout": "Provider timeout",
			"generic_error": "Generic error",
			"rate_limit_exceeded": "Rate limit exceeded",
			"security_violation": "Security violation",
			"processor_error": "Processor error",
			"terminal_closed": "Terminal closed",
			"internal_error": "Internal error",
			"project_validation_error": "Project validation error",
			"temporal_limit_reached": "Temporal limit reached",
			"invalid_currency": "Invalid currency",
			"generic_failure": "Generic failure",
			"card_declined": "Card declined",
			"issuer_failure": "Issuer failure",
			"card_blocked": "Card blocked",
			"issuer_amount_limits": "Issuer amount limits",
			"issuer_frequency_limits": "Issuer frequency limits",
			"failure_url_redirect": "Failure url redirect",
			"account_not_activated": "Account not activated",
			"acs_challenge_request_missing": "Acs challenge request missing",
			"invalid_merchant": "Invalid merchant",
			"transaction_not_permitted_to_cardholder": "Transaction not permitted to cardholder",
			"network_token_deactivated": "Network token deactivated"
		},
		"retryable": "Retryable",
		"analytics_group": "Analytics group",
		"analytics_groups": {
			"empty": "Empty",
			"psp_errors": "PSP errors",
			"cancel_errors": "Cancel errors",
			"rejected_errors": "Rejected errors",
			"user_errors": "User errors",
			"unknown_errors": "Unknown errors"
		},
		"disable_period": "Disable period",
		"disable_periods": {
			"empty": "Empty",
			"week": "Until the end of the week",
			"month": "Until the end of the month"
		},
		"actions": "Actions",
		"created_success": "Failure kind is successfully created",
		"updated_success": "Failure kind is successfully updated",
		"removed_success": "Failure kind is successfully removed",
		"new_failure_kind": "New failure kind",
		"filters": {
			"all": "All"
		},
		"mass_update": {
			"selected": "{count} selected",
			"deselect_all": "Deselect all",
			"apply": "Apply to selected"
		}
	}
};